export default __webpack_public_path__ + "static/media/Quality.694dde77.png";